import type { ReactNode, CSSProperties } from 'react';
import './DashboardGrid.css';

interface DashboardGridProps {
  children: ReactNode;
  /** Grid column template — defaults to '1.5fr 1fr' */
  columns?: string;
  /** Gap between grid items — defaults to 24 */
  gap?: number;
  /** Extra className to append */
  className?: string;
  /** Extra inline styles */
  style?: CSSProperties;
}

/**
 * Reusable responsive grid wrapper for dashboard pages.
 *
 * Renders children in a side-by-side layout on desktop and stacks
 * them vertically on tablets / phones (≤ 1024 px).
 *
 * Usage:
 *   <DashboardGrid>
 *     <WidgetA />
 *     <WidgetB />
 *   </DashboardGrid>
 */
export function DashboardGrid({
  children,
  columns = '1.5fr 1fr',
  gap = 24,
  className = '',
  style,
}: DashboardGridProps) {
  return (
    <div
      className={`dashboard-grid ${className}`.trim()}
      style={{
        '--dg-columns': columns,
        '--dg-gap': `${gap}px`,
        ...style,
      } as CSSProperties}
    >
      {children}
    </div>
  );
}
